import React, {useState} from "react";
import {withRouter} from "react-router";

import {
    BrandIconBox,
    ConsentActions,
    ConsentCard,
    ConsentSubtitle,
    ConsentTitle,
    ConsentWrapper,
    Error,
    ErrorContainer,
    LogosRow,
    PrimaryButton,
    SecondaryLinkButton
} from "../styles";

import {consentUiByClient, defaultConsentUi} from "./oauth-consent-config";

export default withRouter(({location}) => {
    const query = new URLSearchParams(location.search);

    const clientId = query.get("client_id");
    const responseType = query.get("response_type");
    const scope = query.get("scope") || "";
    const oauthRedirectUri = query.get("oauth_redirect_uri");
    const session = query.get("session");
    const state = query.get("state");
    const clientName = query.get("client_name")?.trim() || undefined;

    const normalizedClientName = clientName?.toLowerCase();
    const ui = (clientName && (consentUiByClient[clientName] ?? consentUiByClient[normalizedClientName])) ?? defaultConsentUi;
    const [error, setError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const resetError = () => setError(null);

    const handleDecision = async (decision) => {
        resetError();
        setIsSubmitting(true);

        try {
            const consentUrl = `/oauth/consent?client_id=${encodeURIComponent(clientId)}`;

            const bodyRequest = {
                decision,
                responseType,
                scope,
                oauthRedirectUri,
                session,
                ...(state ? {state} : {})
            };

            const res = await fetch(consentUrl, {
                method: "POST",
                body: JSON.stringify(bodyRequest),
                headers: {"Content-Type": "application/json"}
            });

            const body = await res.json();

            if (res.status === 200 && body?.location) {
                window.location.href = body.location;
                return;
            }

            setError("Unexpected error. Please try again.");
        } catch (e) {
            setError("Unexpected error. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <ConsentWrapper>
            <ConsentCard>
                {ui.logos?.length > 0 && (
                    <LogosRow>
                        {ui.logos.map((l, idx) => (
                            <BrandIconBox
                                key={`${l.label}-${idx}`}
                                aria-label={l.label}
                                $height={l.height}
                                $width={l.width}
                            >
                                {l.node}
                            </BrandIconBox>
                        ))}
                    </LogosRow>
                )}

                <ConsentTitle>{ui.title}</ConsentTitle>
                <ConsentSubtitle>{ui.subtitle}</ConsentSubtitle>

                {error && (
                    <ErrorContainer>
                        <Error>{error}</Error>
                    </ErrorContainer>
                )}

                <ConsentActions>
                    <PrimaryButton
                        type="button"
                        onClick={() => handleDecision("allow")}
                        disabled={isSubmitting}
                    >
                        Allow
                    </PrimaryButton>

                    <SecondaryLinkButton
                        type="button"
                        onClick={() => handleDecision("deny")}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </SecondaryLinkButton>
                </ConsentActions>
            </ConsentCard>
        </ConsentWrapper>
    );
});
